import { useMutation } from '@tanstack/react-query';
import useGetMarketingData from './useGetMarketingData';
import {
  invalidateMarketingData,
  updateAdsUrl,
} from '../../services/marketing';

function useUpdateAdsUrl() {
  const { data, isFetching } = useGetMarketingData();

  return useMutation({
    mutationFn: async (adsUrl: string | null) => {
      if (!data?.id || isFetching) return null;
      return updateAdsUrl(data.id, adsUrl);
    },
    onSuccess: invalidateMarketingData,
  });
}

export default useUpdateAdsUrl;
